import { render, staticRenderFns } from "./item.vue?vue&type=template&id=5a3c8a5d&scoped=true&"
import script from "./item.vue?vue&type=script&lang=js&"
export * from "./item.vue?vue&type=script&lang=js&"
import style0 from "./item.vue?vue&type=style&index=0&id=5a3c8a5d&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/_vue-loader@15.8.3@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5a3c8a5d",
  null
  
)

export default component.exports